import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const UsageTrackerContext = /*#__PURE__*/createContext(undefined);
export function UsageTrackerProvider({
  children,
  tracker
}) {
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: tracker,
    children: children
  });
}
export function MockUsageTrackerProvider({
  children,
  cloneSpy,
  getConfigSpy,
  setPropertiesSpy,
  trackSpy
}) {
  const mockTracker = {
    clone: cloneSpy !== null && cloneSpy !== void 0 ? cloneSpy : jasmine.createSpy('clone'),
    setProperties: setPropertiesSpy !== null && setPropertiesSpy !== void 0 ? setPropertiesSpy : jasmine.createSpy('setProperties'),
    getConfig: getConfigSpy !== null && getConfigSpy !== void 0 ? getConfigSpy : jasmine.createSpy('getConfig'),
    track: trackSpy !== null && trackSpy !== void 0 ? trackSpy : jasmine.createSpy('track')
  };
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: mockTracker,
    children: children
  });
}
export function useUsageTracker() {
  const tracker = useContext(UsageTrackerContext);
  if (!tracker) {
    throw new Error('useUsageTracker must be used within a UsageTrackerProvider');
  }
  return tracker;
}